<template>
    <!--提示框-->
    <div class="toast"><span :class="{'toast-enter-active': isToastShow}">{{toastDesc}}</span></div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: '',
        computed: {
            ...mapGetters(['isToastShow', 'toastDesc'])
        }
    }
</script>

<style lang="scss" scoped>
    /*toast提示*/
    .toast {
        pointer-events: none;
        text-align: center;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 60%;
        z-index: 4000000;
        margin: 0 0.6666667rem;
    }

    .toast span {
        display: inline-block;
        padding: 0.3rem 0.48rem;
        font-size: 0.37333333rem;
        line-height: 0.37333333rem;
        color: #fff;
        background-color: rgba(26, 25, 30, 0.94);
        opacity: 0;

        -webkit-transform: translate3d(0, 120%, 0);
        transform: translate3d(0, 120%, 0);

        -webkit-border-radius: 0.08rem;
        border-radius: 0.08rem;
    }

    @-webkit-keyframes toast {
        11.54% {
            opacity: 1;
            -webkit-transform: translate3d(0, 0, 0);
        }
        87% {
            opacity: 1;
            -webkit-transform: translate3d(0, 0, 0);
        }
        94% {
            opacity: 0.9;
            -webkit-transform: translate3d(0, 0, 0) scale(0.9);
        }
        100% {
            -webkit-transform: translate3d(0, 70%, 0) scale(0.9);
        }
    }

    @keyframes toast {
        11.54% {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
        87% {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
        94% {
            opacity: 0.9;
            transform: translate3d(0, 0, 0) scale(0.9);
        }
        100% {
            transform: translate3d(0, 70%, 0) scale(0.9);
        }
    }

    .toast-enter-active {
        -webkit-animation: toast 2.6s;
        animation: toast 2.6s;
    }
</style>



// WEBPACK FOOTER //
// src/components/MToast/index.vue